import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;
const IsDomainNameExists = (searchText) => {
    cancelToken = getAxiosCancelToken(cancelToken);
    return apiRequestType(apiTypes.GET, apiConstants.ADMIN.ORGANIZATION_SETTINGS.IS_DOMAIN_NAME_EXIST(searchText), "", cancelToken);
}

export default IsDomainNameExists;